import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { DateUtils } from '../../Utils/DateUtils';

var tableId = 'tableSnapshot';
var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface WinPageOptions extends PageOptionsBase {
    urlList: string;
}

export class Snapshot extends PageBase<WinPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;

    constructor(options: WinPageOptions) {
        super(options);

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Name',
            autoWidth: true,
            columns: [
                {
                    data: 'Name',
                    sortable: false,
                    width: "30%",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnSnapshotName${rowData.Name}'>${data}</span>`)
                },
                {
                    data: 'MainCurrencyBeforeWinValue',
                    sortable: false,
                    width: "17%",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnMainCurrencyBeforeWinValue${rowData.Name}'>${data}</span>`)
                },
                {
                    data: 'MainCurrencyAfterWinValue',
                    sortable: false,
                    width: "17%",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnMainCurrencyAfterWinValue${rowData.Name}'>${data}</span>`)
                },
                {
                    data: 'PlayerCurrencyBeforeWinValue',
                    sortable: false,
                    width: "18%",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnPlayerCurrencyBeforeWinValue${rowData.Name}'>${data}</span>`),
                },
                {
                    data: 'PlayerCurrencyAfterWinValue',
                    sortable: false,
                    width: "18%",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnPlayerCurrencyAfterWinValue${rowData.Name}'>${data}</span>`)
                }
            ]
        };
    }

    init(): void {
        // == create 'new Datatable' instance
        this._table = new Datatable(tableId, this._tableOptions);
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ProgressiveBonuses/Snapshot.ts
 **/